import { commonIcons } from '@apps-common/config/icons'

interface IProps {
  siteName?: string
  url: string | null | undefined
  file: any
  loading?: boolean
}

export const ManagementProductImage = ({ url, file, loading }: IProps) => {
  if (loading) {
    return <div className='w-[60px] h-[60px] rounded-full bg-skeleton border border-skeleton-border animate-pulse' />
  }

  if (file) {
    return (
      <img
        src={URL.createObjectURL(file?.blob || file)}
        alt='New selected'
        className='w-[60px] h-[60px] rounded-full border-[1px] border-primary-content'
      />
    )
  }

  if (url) {
    return <img src={url} alt='Site thumbnail' className='w-[60px] h-[60px] rounded-full border-[1px] border-primary-content' />
  }

  return (
    <div className='bg-surface text-text w-[60px] h-[60px] rounded-full border border-text/10 flex items-center justify-center'>
      <div>
        <div className='bg-surface-2 p-1 rounded-full'>
          <commonIcons.add className='text-[1.1rem]' />
        </div>
        <div className='jost-light text-[0.7rem] leading-[0.8rem]'>Add</div>
      </div>
    </div>
  )
}
